export default "__VITE_ASSET__BZlkAfR6__"